import styled from 'styled-components';

export const Header = styled.div`
  padding: 0;
  height: 100%;
  display: grid;
  justify-content: inherit;

  & > label {
    padding-left: 25px;
  }
`;
